<template>
	<div class="bm-icon">
		<div class="bm-icon__row">
			<span class="bm-icon__preview" :class="{'bm-icon__preview--text': isTextIcon}">
				<img v-if="isImageIcon" :src="value" alt="">
				<template v-else>{{ value || '＋' }}</template>
			</span>
			<input
				v-model="iconText"
				type="text"
				maxlength="1000"
				placeholder="留空自动获取站点图标，或选择图标库"
				@input="handleInput"
			>
			<button type="button" class="bm-icon__toggle" @click="open = !open">图标库</button>
		</div>

		<div v-if="open" class="bm-picker">
			<div class="bm-picker__tabs">
				<button
					v-for="(group, index) in groups"
					:key="group.name"
					type="button"
					:class="{'bm-picker__tab--active': groupIndex === index}"
					@click="groupIndex = index"
				>{{ group.name }}</button>
			</div>
			<div class="bm-picker__grid">
				<button
					v-for="icon in currentIcons"
					:key="icon"
					type="button"
					:title="icon"
					@click="pick(icon)"
				>{{ icon }}</button>
			</div>
			<div class="bm-picker__foot">
				<span class="bm-picker__hint">也可粘贴 emoji 或图片地址</span>
				<button type="button" class="bm-picker__clear" @click="clear">清除图标</button>
			</div>
		</div>
	</div>
</template>

<script>
	/**
	 * 图标库分组
	 */
	const ICON_GROUPS = [
		{
			name: '常用',
			icons: ['⭐', '🔥', '💡', '📌', '🚀', '🎯', '📚', '🧩', '🗂️', '❤️', '✅', '🔖', '⚡', '🌟', '💎', '🏷️', '📎', '🧭', '🪄', '🎁', '🏆', '🔔', '📣', '🧱']
		},
		{
			name: '开发',
			icons: ['💻', '🖥️', '⌨️', '🖱️', '⚙️', '🐙', '🐳', '🐍', '☕', '🧪', '🛠️', '📦', '🧬', '🔧', '🐞', '📜', '🗄️', '🔌', '🧑‍💻', '🐧', '🦀', '🐘', '🔩', '🪛', '🛡️', '⚗️']
		},
		{
			name: '工具',
			icons: ['📝', '📊', '🗓️', '⏰', '🔍', '🧮', '🖇️', '🗃️', '📁', '🔐', '🖨️', '✂️', '📋', '🗜️', '🧲', '🔦', '📐', '📏', '🖊️', '🖌️', '🧾', '🧷', '📤', '📥', '🔄', '🎛️', '🧹', '🧰']
		},
		{
			name: '影音',
			icons: ['🎬', '🎵', '🎧', '📺', '🎮', '🕹️', '📷', '🎨', '🖼️', '🎤', '🎼', '🎹', '🎸', '🥁', '🎺', '📻', '🎙️', '🎞️', '📽️', '🔉', '🔊', '▶️', '⏯️', '🎶', '🎻', '🎷', '📀']
		},
		{
			name: '社交',
			icons: ['💬', '📮', '🐦', '📱', '🌐', '👥', '📢', '💌', '🐧', '📡', '🤝', '🫂', '✉️', '📧', '📨', '📲', '📞', '☎️', '🗣️', '👤', '💞', '🧑‍🤝‍🧑', '📣', '❤️‍🔥']
		},
		{
			name: '学习',
			icons: ['📖', '✏️', '🎓', '🧠', '📐', '🔬', '🗒️', '📔', '🏫', '🔖', '📕', '📗', '📘', '📙', '📓', '📒', '📑', '🗞️', '📰', '🎒', '🧑‍🎓', '🧑‍🏫', '🎖️', '🏅']
		},
		{
			name: '生活',
			icons: ['🏠', '🍜', '☕', '🛒', '🏋️', '✈️', '🌤️', '🐱', '🍰', '🍔', '🍕', '🍵', '🥤', '🛏️', '🚿', '🧺', '🧴', '🏡', '🏢', '🍎', '🥗', '🍳', '☔', '🌈', '🎂', '🍻', '🧸']
		},
		{
			name: '自然',
			icons: ['🌿', '🌱', '🌳', '🌲', '🌵', '🌸', '🌺', '🌻', '🌷', '🍀', '🍁', '🌊', '🏔️', '🌋', '🏝️', '🌌', '🌙', '☀️', '⛅', '🌧️', '❄️', '⚡', '🐾', '🦋']
		},
		{
			name: '游戏',
			icons: ['👾', '🎲', '🏆', '⚔️', '🧙', '🎰', '🃏', '🀄', '🎯', '🎪', '🎳', '🎽', '🗡️', '🏹', '🔮', '👑', '🎊', '🎉', '🕹️', '🎮']
		},
		{
			name: '动物',
			icons: ['🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯', '🦁', '🐮', '🐷', '🐸', '🐵', '🐔', '🐧', '🐦', '🦄', '🐝', '🐬', '🐳', '🐙', '🦖', '🐢', '🦔']
		},
		{
			name: '交通',
			icons: ['🚗', '🚕', '🚌', '🚎', '🏎️', '🚓', '🚑', '🚒', '🚲', '🛵', '🏍️', '✈️', '🚀', '🛸', '🚁', '⛵', '🚢', '🚂', '🚆', '🚇', '🛴', '🚜', '🚛', '🛺']
		}
	]

	export default {
		name: 'IconPicker',
		props: {
			/**
			 * 图标值，支持 emoji 文本或图片地址
			 */
			value: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				open: false,
				groupIndex: 0,
				iconText: this.value || ''
			}
		},
		computed: {
			/**
			 * 图标库分组
			 */
			groups() {
				return ICON_GROUPS
			},
			/**
			 * 当前分组下的图标
			 */
			currentIcons() {
				return ICON_GROUPS[this.groupIndex].icons
			},
			/**
			 * 是否为图片地址
			 */
			isImageIcon() {
				return /^(http|data):/i.test((this.value || '').trim())
			},
			/**
			 * 是否为文本图标（emoji）
			 */
			isTextIcon() {
				return !this.isImageIcon && Boolean((this.value || '').trim())
			}
		},
		watch: {
			/**
			 * 外部图标值变化时同步输入框
			 *
			 * @param {String} value 图标值
			 */
			value(value) {
				this.iconText = value || ''
			}
		},
		methods: {
			/**
			 * 输入框内容变化
			 *
			 * @param {Event} event 输入事件
			 */
			handleInput(event) {
				this.$emit('input', event.target.value)
			},
			/**
			 * 选中图标库中的图标
			 *
			 * @param {String} icon 图标
			 */
			pick(icon) {
				this.iconText = icon
				this.$emit('input', icon)
				this.open = false
			},
			/**
			 * 清除图标
			 */
			clear() {
				this.iconText = ''
				this.$emit('input', '')
				this.open = false
			}
		}
	}
</script>

<style scoped>
	.bm-icon__row {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.bm-icon__preview {
		display: flex;
		flex: none;
		align-items: center;
		justify-content: center;
		width: 42px;
		height: 42px;
		border-radius: 12px;
		background: rgba(255, 255, 255, 0.92);
		color: #6b7392;
		font-size: 18px;
		overflow: hidden;
	}

	.bm-icon__preview--text {
		background: linear-gradient(135deg, rgba(120, 150, 255, 0.3), rgba(190, 110, 255, 0.3));
		color: #fff;
		font-size: 22px;
		box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.16);
	}

	.bm-icon__preview img {
		width: 26px;
		height: 26px;
		object-fit: contain;
	}

	.bm-icon__row input {
		flex: 1;
		min-width: 0;
		padding: 10px 12px;
		border: 1px solid rgba(255, 255, 255, 0.12);
		border-radius: 12px;
		background: rgba(255, 255, 255, 0.06);
		color: #eaf0ff;
		font-size: 14px;
		outline: none;
		transition: border-color 0.2s ease, background 0.2s ease;
	}

	.bm-icon__row input::placeholder {
		color: rgba(180, 192, 235, 0.45);
	}

	.bm-icon__row input:focus {
		border-color: rgba(140, 164, 255, 0.6);
		background: rgba(255, 255, 255, 0.11);
	}

	.bm-icon__toggle {
		flex: none;
		padding: 9px 14px;
		border: 1px solid rgba(140, 164, 255, 0.35);
		border-radius: 12px;
		background: rgba(120, 150, 255, 0.12);
		color: #b9c7ff;
		cursor: pointer;
		font-size: 13px;
		transition: background 0.2s ease;
	}

	.bm-icon__toggle:hover {
		background: rgba(120, 150, 255, 0.22);
	}

	.bm-picker {
		margin-top: 10px;
		padding: 12px;
		border: 1px solid rgba(255, 255, 255, 0.1);
		border-radius: 14px;
		background: rgba(255, 255, 255, 0.04);
	}

	.bm-picker__tabs {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
		margin-bottom: 10px;
	}

	.bm-picker__tabs button {
		padding: 4px 12px;
		border: none;
		border-radius: 999px;
		background: rgba(255, 255, 255, 0.07);
		color: rgba(206, 216, 250, 0.7);
		cursor: pointer;
		font-size: 12px;
	}

	.bm-picker__tabs button:hover {
		background: rgba(255, 255, 255, 0.14);
	}

	.bm-picker__tab--active {
		background: linear-gradient(135deg, #6d7dff, #b06bff) !important;
		color: #fff !important;
	}

	.bm-picker__grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(40px, 1fr));
		gap: 6px;
		max-height: 240px;
		overflow-y: auto;
		padding-right: 2px;
	}

	.bm-picker__grid::-webkit-scrollbar {
		width: 6px;
	}

	.bm-picker__grid::-webkit-scrollbar-thumb {
		border-radius: 3px;
		background: rgba(255, 255, 255, 0.18);
	}

	.bm-picker__grid button {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 40px;
		border: 1px solid transparent;
		border-radius: 10px;
		background: rgba(255, 255, 255, 0.06);
		color: inherit;
		cursor: pointer;
		font-size: 20px;
		line-height: 1;
		transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
	}

	.bm-picker__grid button:hover {
		border-color: rgba(150, 175, 255, 0.4);
		background: rgba(255, 255, 255, 0.14);
		transform: translateY(-2px);
	}

	.bm-picker__foot {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		margin-top: 10px;
	}

	.bm-picker__hint {
		color: rgba(180, 192, 235, 0.45);
		font-size: 11px;
	}

	.bm-picker__clear {
		flex: none;
		padding: 4px 12px;
		border: none;
		border-radius: 999px;
		background: rgba(255, 255, 255, 0.08);
		color: rgba(206, 216, 250, 0.7);
		cursor: pointer;
		font-size: 12px;
	}

	.bm-picker__clear:hover {
		background: rgba(255, 255, 255, 0.16);
	}
</style>
